var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"1rem"}},_vm._l((_vm.folders),function(folder){return _c('folder-element',{key:folder.id,attrs:{"folder":folder},on:{"openGeneralUploadModal":function($event){_vm.$emit('openGeneralUploadModal', $event)}}})}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdd57ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/FolderRow.vue
// module id = YGfK
// module chunks = 0